/* eslint-disable react/prop-types */
import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Typography from '@mui/material/Typography';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import API_URL from '../../../services';

function createData(date, product, quantity, seller, status) {
  return {
    date,
    product,
    quantity,
    seller,
    status,
    history: [
      {
        history: '2020-01-05',
        customerId: '11091700',
        amount: 3,
      },
      {
        date: '2020-01-02',
        customerId: 'Anonymous',
        amount: 1,
      },
    ],
  };
}

export function Row(props) {
  const { row, index } = props;
  const isEven = Boolean(index % 2); //eslint-disable-line
  const randNum = Math.floor(Math.random() * (10 - 0 + 1));
  const isActive = Boolean(randNum % 2);
  const [open, setOpen] = React.useState(false);
  const { created_date: createdDate } = row;
  const dateSplit = createdDate.split('T');
  const date = dateSplit[0];
  const {
    product:
      {
        img, status, name, brand, in_stock: inStock,
      },
  } = row;

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className={`hover:bg-gray-100 ${isEven ? 'bg-white' : 'bg-gray-100'}`}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {date}
        </TableCell>
        <TableCell align="left">{row.product.name}</TableCell>
        <TableCell align="left">34</TableCell>
        <TableCell align="left">{row.company.name}</TableCell>
        <TableCell align="left">
          <span className={`uppercase py-1 px-2 rounded-lg text-xs ${inStock ? 'bg-[#bbf7d0] text-green-700' : 'bg-[#fcd34d] text-yellow-700'}`}>
            {`${isActive ? 'Active' : 'Pending'}`}
          </span>
        </TableCell>
        <TableCell>
          <Button variant="outlined" color="error" size="small">Cancel</Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Product Detail
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Image</TableCell>
                    <TableCell>Brand</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>In Stock</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{ name }</TableCell>
                    <TableCell component="th" scope="row">
                      <img src={`${API_URL}/${img}`} loading="lazy" alt="..." width={100} />
                    </TableCell>
                    <TableCell>{ brand }</TableCell>
                    <TableCell>{ status }</TableCell>
                    <TableCell>
                      <span className={`py-2 px-3 rounded-lg text-sm ${inStock ? 'bg-[#bbf7d0] text-green-700' : 'bg-[#fcd34d] text-yellow-700'}`}>
                        {`${inStock ? 'Available' : 'Available in order'}`}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    created_date: PropTypes.string.isRequired,
    company: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    product: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0, 3.99),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3, 4.99),
  createData('Eclair', 262, 16.0, 24, 6.0, 3.79),
  createData('Cupcake', 305, 3.7, 67, 4.3, 2.5),
  createData('Gingerbread', 356, 16.0, 49, 3.9, 1.5),
];
